import extractUserIdentity from '../utils/extractUserIdentity';
import valueFromHeader from '../utils/valueFromHeader';
import { SET_REQUEST_CONTEXT, SET_REQUEST_DETAILS } from './types';

export function mapHostName(hostname) {
  // Hostname can have multiple comma-separated values. New values are appended, so
  // the last value will have been set by us in Cloudflare/Fastly. Trust that.
  return hostname
    .split(',')
    .pop()
    .trim();
}

export function setRequestContext(req) {
  const consumerAuthToken = valueFromHeader(req.cookies.consumer_auth_token);
  const unverifiedUserId = extractUserIdentity(consumerAuthToken);

  return {
    type: SET_REQUEST_CONTEXT,
    payload: {
      country: req.country,
      host: `${req.protocol}://${mapHostName(req.hostname)}`,
      apiAuth: consumerAuthToken,
      unverifiedUserId,
      rooGuid: req.cookies.roo_guid,
      rooSessionGuid: req.cookies.roo_session_guid,
      rooStickyGuid: req.cookies.roo_sticky_guid,
      locale: req.locale,
      ip: req.ip,
      userAgent: valueFromHeader(req.headers['user-agent']),
      referer: valueFromHeader(req.headers.referer),
      googleApiKey: process.env.GOOGLE_API_KEY,
      seenCookieMessage: Boolean(req.cookies.seen_cookie_message),
      lastHomeFeed: req.cookies.cwa_last_home_feed,
    },
  };
}

export function setRequestDetails(url, query) {
  return {
    type: SET_REQUEST_DETAILS,
    payload: {
      url,
      query,
    },
  };
}
